import { useEffect, useCallback } from 'react'
import { sendReady, sendEvent, sendScrollToTop, sendRedirect, isInIframe } from '../_lib/postMessage'
import type { EmbedEventType } from '../_types/embed'

/**
 * Hook to manage postMessage communication with parent window
 */
export function useEmbedMessenger() {
  // Send ready message when component mounts
  useEffect(() => {
    if (isInIframe()) {
      sendReady()
    }
  }, [])

  // Broadcast an event to parent
  const broadcastEvent = useCallback((event: EmbedEventType, data?: any) => {
    if (isInIframe()) {
      sendEvent(event, data)
    }
  }, [])

  // Request scroll to top
  const scrollToTop = useCallback(() => {
    if (isInIframe()) {
      sendScrollToTop()
    }
  }, [])

  // Request redirect
  const redirect = useCallback((url: string) => {
    if (isInIframe()) {
      sendRedirect(url)
    } else {
      // If not in iframe, just navigate directly
      window.location.href = url
    }
  }, [])

  return {
    broadcastEvent,
    scrollToTop,
    redirect,
    isInIframe: isInIframe(),
  }
}
